import { Dropdown, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { VatFilterProps } from '../../types';
import SolarIcon from 'components/icons/SolarIcon';

const VatFilter = ({
    vat,
    setVat,
    includeObjects,
    includeSales,
    includeServiceSales,
    showSales,
    onTypeChange,
}: VatFilterProps) => {
    const { t } = useTranslation(['Reports']);
    const filterActive =
        vat !== null || !includeObjects || (showSales && (!includeSales || !includeServiceSales));
    const variant = filterActive ? 'danger' : 'primary';

    return (
        <Dropdown autoClose="outside">
            <Dropdown.Toggle
                className="fs-14 px-2"
                size="sm"
                variant={variant}
                id="dropdown-basic"
                title={t('toolArchiveFilter')}
            >
                <SolarIcon name="funnel" className="fs-14 p-0" />
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <div className="px-3 py-2 d-flex flex-column gap-2" onClick={(e) => e.stopPropagation()}>
                    <Form.Check
                        type="switch"
                        id="report-include-objects"
                        className="mb-0 text-nowrap"
                        label={t('reportFilter.objects')}
                        checked={includeObjects}
                        onChange={(e) => onTypeChange({ includeObjects: e.target.checked })}
                    />
                    {showSales ? (
                        <>
                        <Form.Check
                            type="switch"
                            id="report-include-sales"
                            className="mb-0 text-nowrap"
                            label={t('reportFilter.sales')}
                            checked={includeSales}
                            onChange={(e) => onTypeChange({ includeSales: e.target.checked })}
                        />
                        <Form.Check
                            type="switch"
                            id="report-include-service-sales"
                            className="mb-0 text-nowrap"
                            label={t('reportFilter.serviceSales')}
                            checked={includeServiceSales}
                            onChange={(e) => onTypeChange({ includeServiceSales: e.target.checked })}
                        />
                        </>
                    ) : null}
                </div>

                <Dropdown.Divider />

                <Dropdown.Item as="button" onClick={() => setVat(null)}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={vat === null}
                            onChange={() => setVat(null)}
                        />
                        {t('reportFilter.all')}
                    </div>
                </Dropdown.Item>

                <Dropdown.Item as="button" onClick={() => setVat(0)}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={vat === 0}
                            onChange={() => setVat(0)}
                        />
                        {t('reportFilter.noVat')}
                    </div>
                </Dropdown.Item>

                <Dropdown.Item as="button" onClick={() => setVat(1)}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={vat === 1}
                            onChange={() => setVat(1)}
                        />
                        {t('reportFilter.withVat')}
                    </div>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default VatFilter;
